var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b{fill:#fff;}.c,.d{fill:#c8d1ec;}.d{fill-rule:evenodd;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 11.5,
    y: 6.5,
    width: 33.704,
    height: 43.152,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8e96ae",
    floodOpacity: 0.322
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 56,
    height: 56,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -13, -8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-109.3-54.847A15.253,15.253,0,0,0-124.648-70,15.253,15.253,0,0,0-140-54.847c0,9.849,15.352,25,15.352,25S-109.3-45-109.3-54.847",
    transform: "translate(153 78)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.581 3.977)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M902.75,255.722v.031a2.219,2.219,0,0,0,.713,1.6,6.655,6.655,0,0,1,2.005,4.854v.077a6.055,6.055,0,0,1-6.116,6.383,6.221,6.221,0,0,1-6.154-6.46v-.076a6.591,6.591,0,0,1,2-4.886,2.164,2.164,0,0,0,.715-1.583h0a2.112,2.112,0,0,0-3.441-1.639,10.447,10.447,0,0,0-3.9,8.184v.077a10.438,10.438,0,0,0,10.7,10.435,10.552,10.552,0,0,0,10.817-10.512v-.076a10.337,10.337,0,0,0-3.828-8.1A2.161,2.161,0,0,0,902.75,255.722Z",
    transform: "translate(-888.573 -252.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1016.17,237.472a1.963,1.963,0,1,1,1.963,1.963,1.963,1.963,0,0,1-1.963-1.963",
    transform: "translate(-1007.381 -235.509)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateStation);
export default __webpack_public_path__ + "static/media/private_station.35f221a4be2e5f5807496b67c96cba4d.svg";
export { ForwardRef as ReactComponent };